const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const fetchOwnerSubstores = async () => {
  const token = localStorage.getItem('token');
  const res = await fetch(`${BASE_URL}/owner/substores/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Token ${token}` } : {})
    },
    credentials: 'include'
  });
  if (!res.ok) {
    const errorText = await res.text();
    console.error('Failed to fetch owner substores:', res.status, errorText);
    throw new Error(`Failed to fetch owner substores: ${res.status}`);
  }
  
  // Check if response is JSON
  const contentType = res.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    const responseText = await res.text();
    console.error('Non-JSON response received:', responseText.substring(0, 200));
    throw new Error('Received non-JSON response from API');
  }
  
  const data = await res.json();
  return data;
};

export async function deleteSubstore(id) {
  const token = localStorage.getItem('token');
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const res = await fetch(`${baseUrl}/api/owner/substores/${id}/delete/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Token ${token}` } : {})
    },
    credentials: 'include'
  });
  if (!res.ok) {
    const message = await res.text().catch(() => 'Failed to delete substore');
    throw new Error(message || 'Failed to delete substore');
  }
}